module.exports = __webpack_public_path__ + "img/object-feature-distraction-before.31c62ad9.webp";